<template>
  <div>
    <b-modal
      :ok-disabled="okButtonDisabled"
      size="xl"
      @ok="saveNewAddress"
      @hidden="changeAddressModalHidden"
      ref="change-address-modal"
      :title="modalTitle"
    >
      <b-row>
        <b-col>
          <b-row v-show="newAddressFormShown">
            <b-col cols="8">
              <b-row>
                <b-col cols="4">
                  <b-form-group label="Type" label-cols="3" label-align="right">
                    <b-form-select id="addressType" v-model="address.addressTypeId">
                      <option v-for="(type) in sortSelect(addressTypes)" v-bind:key="type.id" v-bind:value="type.id">{{type.name}}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </b-col>        
                
                <b-col cols="2">
                  <b-form-group>
                    <b-form-checkbox v-model="address.isDefault" inline>
                      Is Default
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>        
                <b-col cols="4" v-if="showVatField">
                  <b-form-group label="VAT/CNPJ/RFC" label-cols="4">
                    <b-form-input  v-model.trim="address.addressVAT" :placeholder="companyTax"></b-form-input>
                  </b-form-group>  
                </b-col>
                
              </b-row>
              <b-row>
                <b-col>
                    <b-form-group label="Tester" label-cols="1" label-align="right" v-if="multiAcctAddress && shipTo == 1" class="required">
                      <b-form-select id="testHouseOption" v-model="selectedTestHouse" @input="setAddressDefaults" >
                        <option v-for="(type) in sortSelect(testHousesOptions)" v-bind:key="type.id" v-bind:value="type.id">{{type.name}}
                        </option>
                      </b-form-select>
                    </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                    <b-form-group class="address-name" label="Name" label-cols="1" label-align="right">
                      <b-form-input  v-model.trim="address.name" @input="addressNameInput"></b-form-input>
                      <!-- <b-form-invalid-feedback>Address Name is required</b-form-invalid-feedback> -->
                    </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Address 1" label-cols="1" label-align="right">
                    <b-form-input type="text" id="address1" v-model="address.address1"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Address 2" label-cols="1" label-align="right">
                    <b-form-input type="text" id="address2" v-model="address.address2"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Address 3" label-cols="1" label-align="right">
                    <b-form-input type="text" id="address3" v-model="address.address3"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="City" label-cols="3" label-align="right">
                    <b-form-input type="text" id="city" v-model="address.city"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="State / Province" label-cols="4" label-align="right">
                    <b-form-input type="text" id="state" v-model="address.state"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Zip Code" label-cols="3" label-align="right">
                    <b-form-input type="text" id="zipcode" v-model="address.zipCode"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Country" label-cols="1" label-align="right">
                    <b-form-select id="country" v-model="address.countryCode">
                      <option v-for="(countryCode) in sortSelect(countryCodes,'country')" v-bind:key="countryCode.code2"
                              v-bind:value="countryCode.code2">{{countryCode.country}}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Contact" label-cols="3" label-align="right">
                    <b-input-group size="sm">
                      <b-input-group-append v-show="accountId > 0">
                        <b-button variant="light" @click="$refs.addNewContact.newContact()" :disabled="shipTo == 1 && selectedTestHouse == 0">
                          <i class="customer-lookup--plus fa fa-plus"></i>
                        </b-button>
                      </b-input-group-append>
                      <b-form-select  v-model="address.contactId" @change="onContactChange">
                        <option :value="0"></option>
                        <option v-for="(select, index) in sortSelect(contacts,'firstName')" :key="index" :value="select.id">
                          {{ select.firstName + ' ' + select.lastName }}</option>
                      </b-form-select>
                    </b-input-group>
                  </b-form-group>
                  <edit-contact
                    :companyId="companyIdForNewContact"
                    ref="addNewContact"
                    :inlineButton="true"
                    :isQuickAdd="true"
                    @created="onContactCreated"></edit-contact>
                </b-col>
                <b-col>
                  <b-form-group label="Phone" label-cols="2" label-align="right">
                    <b-form-input type="text" v-model="address.phone"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Fax" label-cols="2" label-align="right">
                    <b-form-input type="text" v-model="address.fax"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="4">
              <b-form-group label="The address will within the forms and printouts appears as below">
                <b-textarea :value="getFormatedAddress" disabled cols="15" rows="10"/>
              </b-form-group>
            </b-col>
          </b-row>

          <b-form-group>
            <b-form-checkbox-group v-model="selectedAddressTypes">
              <a class="d-inline mr-4">Show:</a>
              <b-form-checkbox value="Billing">Billing</b-form-checkbox>
              <b-form-checkbox value="Shipping">Shipping</b-form-checkbox>
              <b-form-checkbox value="General">General</b-form-checkbox>
              <b-form-checkbox value="Warehouse">Warehouse</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>

          <div class="card">
            <div class="card-header">
              <i class="fa fa-align-justify"></i>
              Addresses List
              <div>
                <b-form-group label-cols="6" v-if="multiAcctAddress">
                  <b-form-radio v-model="shipTo" name="shipTo" :value="0" inline>House</b-form-radio>
                  <b-form-radio v-model="shipTo" name="shipTo" :value="1" inline>Test House</b-form-radio>
                  <b-form-radio v-model="shipTo" name="shipTo" :value="2" inline>Customer</b-form-radio>
                </b-form-group>
              </div>
              
              <div class="pull-right tools">
                <!-- <b-button v-if="showDropShip && !newAddressFormShown" class="mr-2" size="sm" @change="onTickDropShip">
                  <b-form-checkbox v-model="isDropOffState"> Drop Ship</b-form-checkbox>
                </b-button> -->
                
                <b-button v-show="!newAddressFormShown" @click="showNewAddressForm" size="sm" variant="primary"
                          title="Add New">
                  <i class="fa fa-plus mr-2" aria-hidden="true"></i>Add New
                </b-button>
                <div v-show="newAddressFormShown">
                  <b-button v-if="address.id" @click="copyAddress" class="mr-2" size="sm" variant="warning" title="Copy"
                            :disabled="isSaving">
                    <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i> Copy
                  </b-button>
                  <!--<b-button v-else class="mr-2" size="sm" variant="warning" title="Copy" :disabled="isSaving">
                    <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i> Copy
                  </b-button>-->
                  <b-button @click="hideNewAddressForm" class="mr-2" size="sm" variant="secondary" title="Cancel">
                    Cancel
                  </b-button>
                  <b-button @click="addNewAddressToTable" size="sm" variant="primary" title="Save" :disabled="isSaving">
                    <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save
                  </b-button>
                </div>
              </div>
            </div>
            <grid-component
              v-if="!newAddressFormShown"
              isResizable
              isReorderable
              :navigationField="'addressTypeName'"
              :gridId="gridId"
              :itemData="addressesListSelected"
              :fields="fields"
              :onEdit="pushToDetails"
              :onDelete="onDelete"
              :handleRowClick="rowClicked"
            />
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <div class="d-flex justify-content-between">
      <a class="address-selector-title">{{ title }}</a>
      <!-- <b-alert variant="info" v-if="showDropShipLabel" show size="sm" class="drop-ship-highlight">Drop Ship</b-alert> -->
      <a class="address-selector-link" @click="openAddressModal" v-if="!hideChange">Change</a>
    </div>
    <!--    <div :style="`width: ${width}px`" style="border: 1px solid; padding: 3px" v-html="value"></div>-->
    <b-textarea
      v-model="value"
      disabled
      :style="`width: ${width}px`"
      rows="8"
    />
    <!-- :rows="(value)?value.split(/\r*\n/).length:7" -->
  </div>
</template>

<script>
  import { mapGetters, mapActions , mapState, mapMutations} from 'vuex';
  // import { required } from 'vuelidate/lib/validators';
  import { GRID_ID, AEGIS_ACCOUNT_ID } from '@/shared/constants';
  import addressFields from './fields';
  import GridComponent from '@/shared/components/GridComponent';
  import EditContact from '@/pages/Company/components/CompanyDetails/tabs/Contacts/components/EditContact/index';

  export default {
    components: {
      GridComponent,
      EditContact
    },
    props: [
      'value',
      'title',
      'accountId',
      'customerId',
      'width',
      'hideChange',
      'addressId',
      'showDropShip',
      'isDropShip',
      'multiAcctAddress',
      'shipToCompanyId'
    ],
    data() {
      return {
        content: this.value,
        address: {},
        currentTypeId: 1,
        fields: addressFields,
        buttonsHeaderVisible: true,
        gridId: GRID_ID.SHARED_ADDRESSES,
        activeEditId: 0,
        fullAddressString: '',
        isEdit: false,
        newAddressFormShown: false,
        selectedAddressTypes: ['Billing', 'Shipping', 'General', 'Warehouse'],
        okButtonDisabled: true,
        rowClickedAddressId: 0,
        tableHidden: false,
        addressValue: this.value,
        isSaving: false,
        isCopied: false,
        isDropOffState: false,
        aegisAcctId: AEGIS_ACCOUNT_ID,
        shipTo: -1,
        selectedTestHouse: 0
      };
    },
    validations: {
      address: {
        // name: { required },
      }
    },
    computed: {
      /*...mapGetters('quoteDetails', [ 'contacts' ]),*/
      ...mapGetters('quoteDetails', {contacts: 'companyContacts' }),
      ...mapGetters('companies', ['companyById']),
      modalTitle(){
        return "Edit Address" + ((this.address && this.address.companyName) ? ` for: ${this.address.companyName}` : '');
      },
      company() {
        var result = this.companyById(this.accountId);
        return result;
      },
      companyId() {
        return this.$route.params.id;
      },
      ...mapState('address', [
        'addressesList',
        'addressTypes',
        'countryCodes',
        'testHousesAddresses'
      ]),
      ...mapGetters('account', ['gridSettingsById']),
      gridSettings() {
        return this.gridSettingsById(GRID_ID.ADDRESSES);
      },
      filterAddressType() {
        const address = this.shipTo == 1 ? this.testHousesAddresses : this.addressesList;
        if (address.length > 0) {
          const filtered = address.filter(address => this.selectedAddressTypes.includes(address.addressTypeName));

          return filtered;
        } else {
          return [];
        }
      },
      addressesListSelected() {
        if(this.rowClickedAddressId){
          const hasAddress = this.filterAddressType.find(obj =>  (obj.id == this.rowClickedAddressId));
          if(hasAddress) {this.address = hasAddress}
        }

        return this.filterAddressType.map((address) => ({
          ...address,
          selected: address.id === this.rowClickedAddressId,
        }));
      },
      showDropShipLabel() {
        return this.showDropShip && this.isDropOffState && this.addressesListSelected.filter(x => x.selected == true).length > 0;
      },
      getFormatedAddress(){
        this.addAddressToTextarea(this.address)
        return this.fullAddressString
      },
      companyTax() {
        let companyTax = this.addressesListSelected.find(x => x.taxId != null || x.vatNumber != null)

        if (companyTax) {
          return companyTax.taxId != null ? companyTax.taxId : companyTax.vatNumber != null ? companyTax.vatNumber : '';
        } else {
          return '';
        }
      },
      testHousesOptions() {
        let options = [];
        let testHouseIds = [ ...new Set(this.testHousesAddresses.map(addr => addr.accountId)) ];
        for (let i = 0; i < testHouseIds.length; i++) {
          let addr = this.testHousesAddresses.find(x => x.accountId == testHouseIds[i]);

          if (addr) {
            options.push({
              id: addr.accountId, 
              name: addr.companyName
            })
          }
        }

        return options;
      },
      showVatField() {
        if (this.multiAcctAddress) {
          return this.address.addressTypeId == 3 && this.shipTo == 2;
        } else {
          return this.address.addressTypeId == 3 
        }
      },
      companyIdForNewContact() {
        if (this.multiAcctAddress) {
          if (this.shipTo == 1) {
            return this.selectedTestHouse;
          } else {
            return this.getActiveAccountId();
          }
        } else {
          return this.accountId;
        }
      }
    },
    methods: {
      ...mapActions('address', [
        'getAddresses',
        'getAddressTypes',
        'getAddressById',
        'getCountryCodes',
        'getTestHouseAddresses',
        'manage',
        'deleteRecord',
      ]),
      // ...mapActions('quotes', ['updateRecord']),
      ...mapActions('account', ['saveGridSettings']),
      ...mapActions('quoteDetails', [ 'getCompanyContacts' ]),
      ...mapMutations('quoteDetails', [ 'setItem' ]),
      addressNameInput() {
        if (this.address.name == '') {
          this.address.name = this.company.name;
        }
      },
      async onContactCreated(id) {
        await this.getCompanyContacts(this.companyIdForNewContact);
        this.address.contactId = id;
      },
      async openAddressModal() {
        this.$refs['change-address-modal'].show();
        
        this.getAddressList();
        // this.getAddressTypes();
        // this.getCountryCodes();
        let acctId = this.getActiveAccountId();

        if (this.contacts.length == 0 || this.contacts.filter(x => x.accountId == acctId).length == 0)
          this.getCompanyContacts(acctId);
      },
      closeAddressModal() {
        this.$refs['change-address-modal'].hide();
      },
      onContactChange() {
        const contact = this.contacts.find(x => x.id == this.address.contactId);
        this.address.contactName = (contact) ? contact.firstName + ' ' + contact.lastName : '';
        this.address.phone = (contact) ? contact.phone1 : '';
        this.addAddressToTextarea(this.address)
      },
      showNewAddressForm() {
        // this.address = {
        //   name: (this.addressesList.length) ? this.addressesList[0].companyName : (Object.keys(this.company).length) ? this.company.name : null
        // };
        this.fullAddressString = '';
        this.newAddressFormShown = true;
        this.isEdit = false;
        this.rowClickedAddressId = 0;
        this.okButtonDisabled = true;
        this.setAddressDefaults();
      },
      setAddressDefaults() {
        if(this.multiAcctAddress && this.shipTo > -1) {
          // use the address list if not in test house
          if (this.shipTo != 1 && this.addressesList.length > 0) {
            // look for address that at least has a phone number
            let companyWPhoneAddr = this.addressesList.find(x => x.phone != null && x.companyName != null);
            // if found, use this details
            if (companyWPhoneAddr) {
              this.address = {
                name: companyWPhoneAddr.companyName,
                phone: companyWPhoneAddr.phone,
                fax: companyWPhoneAddr.fax
              };  
            } 
            // use the first addr only
            else {
              let firstAddr = this.addressesList[0];

              this.address = {
                name: firstAddr.companyName,
                phone: firstAddr.phone,
                fax: firstAddr.fax
              };  
            }
          }
          // use the test house address
          else if (this.testHousesAddresses.length > 0 && this.shipTo == 1) {
            if (this.selectedTestHouse > 0) {
              let addr = this.testHousesAddresses.find(x => x.accountId == this.selectedTestHouse);
              this.getCompanyContacts(this.selectedTestHouse);
              if (addr) {
                this.address = {
                  name: addr.companyName,
                  phone: addr.phone,
                  fax: addr.fax
                }
              } else {
                this.address = {
                  name: '',
                  phone: '',
                  fax: ''
                };
              }
            } else {
              this.address = {
                name: '',
                phone: '',
                fax: ''
              };
              this.setItem({resource: 'companyContacts', payload: []});
            }
          } else {
            this.address = {
              name: '',
              phone: '',
              fax: ''
            };
          }
        } else {
          this.address = {
            name: this.company.name,
            phone: this.company.phone1,
            fax: this.company.fax1
          };  
        }
      },
      hideNewAddressForm() {
        this.$v.$reset();
        this.isCopied = false;
        this.newAddressFormShown = false;
      },
      saveNewAddress() {
        this.addAddressToTextarea(this.address);
        this.$emit('input', {
          id: this.address.id,
          newAddr: this.fullAddressString,
          isDropShip: this.shipTo == 2,
        });
        this.closeAddressModal();
      },
      addAddressToTextarea(result) {
        this.fullAddressString = '';
        if(result.name != undefined) {
          if (result.name == '') this.fullAddressString = this.company.name + '\n';
          else if (result.name != '') this.fullAddressString = result.name + '\n';
        }
        if (result.address1) this.fullAddressString += result.address1 + '\n';
        if (result.address2) this.fullAddressString += result.address2 + '\n';
        if (result.address3) this.fullAddressString += result.address3 + '\n';
        if (result.city) this.fullAddressString += result.city;
        if (result.state) this.fullAddressString += ((result.city)?', ':'') + result.state;
        if (result.zipCode) this.fullAddressString += ((result.city || result.state)?', ':'') + result.zipCode + '\n';
        if (result.countryCode) {
          const selectedCountry = _.find(this.countryCodes, {code2: result.countryCode});
          if (typeof selectedCountry !== 'undefined') {
            this.fullAddressString += ((!result.zipCode)?'\n':'') + selectedCountry.country + '\n';
          }
        }
        if (result.contactName) this.fullAddressString += 'Contact Name: ' + result.contactName + '\n';
        if (result.phone == '' && this.company.phone1) this.fullAddressString += 'Phone: ' + this.company.phone1 + '\n';
        else if (result.phone) this.fullAddressString += 'Phone: ' +result.phone + '\n';
        if (result.fax == '' && this.company.fax1) this.fullAddressString += 'Fax: ' + this.company.fax1 + '\n';
        else if (result.fax) this.fullAddressString += 'Fax: ' +result.fax + '\n';
        if (result.addressTypeId == 3 && result.addressVAT) this.fullAddressString += 'VAT/RFC/CNPJ: ' + result.addressVAT
        else if(result.countryCode) {
          if (result.countryCode == 'US' && result.taxId) this.fullAddressString += 'Tax ID: ' + result.taxId;
          else if (result.vatNumber) this.fullAddressString += 'VAT/RFC/CNPJ: ' + result.vatNumber;
        }
      },
      setDefaultFromCompany() {
        if (this.address.name == '' || this.address.name == null || this.address.name == undefined) this.address.name = this.company.name;
        if (this.address.phone == '' || this.address.phone == null || this.address.phone == undefined) this.address.phone = this.company.phone1;
        if (this.address.fax == ''  || this.address.fax == null || this.address.fax == undefined) this.address.fax = this.company.fax1;
      },
      async addNewAddressToTable() {
        this.$v.address.$touch();
        if (this.$v.address.$invalid) {
          return;
        } else {
          try {
            this.isSaving = true;
            // this.address.addressTypeId = this.currentTypeId;

            if (this.address.id) {
              let deleteConfirmed = true;
              if (!this.isCopied) {
                deleteConfirmed = await this.openConfirmBox({
                  message: `Updating an address will affect all records associated to this address. Please press OK to continue`,
                  size: 'sm',
                });
              }
              if (deleteConfirmed) {
                this.setDefaultFromCompany();
                /*let {id} = await this.editAddress(this.address);*/
                let {id} = await this.manage(this.address);;
                if (id) {
                  this.getAddressList();
                  this.hideNewAddressForm();
                }
              }
            } else { //New address
              if (this.shipTo == 1 && !this.selectedTestHouse) {
                await this.openAlertBox({ message: 'Please select the test house this address relates into.' });
                this.isSaving = false;
                return;
              }
              this.address.id = 0;
              
              this.address.accountId = (this.shipTo == 1) ? this.selectedTestHouse : this.getActiveAccountId();
              if (!this.shipTo) this.setDefaultFromCompany();
              /*let {id} = await this.addNewAddress(this.address);*/
              let {id} = await this.manage(this.address);;
              if (id) {
                this.getAddressList();
                this.hideNewAddressForm();
              }
            }
            this.isSaving = false;
          } catch (e) {
            this.isSaving = false;
          }
        }
      },
      async getAddressList() {
        let id = this.getActiveAccountId();
        if (this.multiAcctAddress) {
          if (this.shipTo != 1) { // Getting addresses on test houses            
            this.getAddresses(id);
          } else if (this.shipTo == 1 && this.testHousesAddresses.length == 0) {
            this.getTestHouseAddresses();
          }
        } else {
          this.getAddresses(id);
        }
        
      },
      rowClicked(event) {
        this.okButtonDisabled = false;
        this.rowClickedAddressId = event.dataItem.id;
        this.address = event.dataItem;
      },
      changeAddressModalHidden() { //Reset modal
        this.hideNewAddressForm();
        this.isEdit = false;
      },
      async copyAddress() {
        try {
          this.isSaving = true;
          this.address = {...this.address, id: 0, isDefault: false};
          /*this.address = await this.addNewAddress(this.address);*/
          this.address = await this.manage(this.address);;
          this.getAddressList();
          this.isSaving = false;
          this.isCopied = true;
        }catch (e) {
          this.isSaving = false;
          this.isCopied = false;
        }
      },
      async pushToDetails(row) {
        this.newAddressFormShown = true;
        this.address = row;
        await this.getCompanyContacts(row.accountId);
      },
      async onDelete(row) {
        const deleteConfirmed = await this.openConfirmBox({});
        if (deleteConfirmed) {
          /*await this.deleteAddress(row.id);*/
          await this.deleteRecord(row.id);
          this.getAddressList();
        }
      },
      getActiveAccountId() {
        if (this.multiAcctAddress) { //
          if (this.isDropOffState) { // on Customer's Address
            // this.shipTo = 2;
            return this.customerId;
          } else if (this.shipToCompanyId != this.aegisAcctId) { // on Test House Address
            // this.shipTo = 1;
            return this.shipToCompanyId;
          } else {
            // this.shipTo = 0;
            return this.aegisAcctId
          }
        } else {
          return this.accountId;
        }
      },
      getIdByShipTo() {
        if (this.isDropOffState && this.shipTo == 2) {
          return this.customerId;
        } else if (this.shipTo == 1) {
          return this.shipToCompanyId
        } else if (this.shipTo == 0) {
          return this.aegisAcctId;
        } else {
          return 0;
        }
      }
    },
    watch: {
      addressId(){
        this.rowClickedAddressId = this.addressId;
      },
      isDropShip() {
        this.isDropOffState = this.isDropShip;
      },
      customerId() {
        if (this.isDropShip && this.showDropShip) {
          this.getAddresses(this.customerId);
        }
      },
      shipTo() {
        this.isDropOffState = this.shipTo == 2;
        let id = this.getIdByShipTo();
        
        this.getAddresses(id).then(() => {
          this.setAddressDefaults();  
        });
        
      }
    },
    mounted() {
      if (this.multiAcctAddress) {
        this.getTestHouseAddresses().then(() => {
          if (this.shipTo == -1) {
            // this.getActiveAccountId();
            let isTestHouse = this.testHousesAddresses.find(x => x.accountId == this.shipToCompanyId)
            if (isTestHouse) { 
              this.shipTo = 1;
            } else if (this.shipToCompanyId != this.aegisAcctId) { // on Test House Address
              this.shipTo = 2;
              this.isDropOffState = true;
            } else {
              this.shipTo = 0;
            }
          } else {
            return this.accountId;
          }
         
        });
      }  
      
      this.rowClickedAddressId = this.addressId;
      this.isDropOffState = this.isDropShip;
    },
    beforeDestroy() {
      this.fullAddressString = '';
    }
  };
</script>

<style lang="scss">
  .address-selector-title {
    color: #73818f !important;
    font-size: 80%;
    font-weight: 700;
    padding-bottom: 1px;
  }

  .address-selector-link {
    color: #20a8d8 !important;
    font-size: 80%;
    font-weight: 700;
    padding-bottom: 1px;
  }

  .address-selector-link:hover {
    color: #167495 !important;
    text-decoration: underline !important;
    cursor: pointer;
  }

  .drop-ship-highlight {
    cursor: default;
    text-align: center;
    width: 100px;
    margin-top: -0.5rem;
    margin-bottom: 0rem !important;
    padding: 0rem !important;
  }
</style>
